module.exports = __webpack_public_path__ + "img/icon_6.a5acd06.svg";